import { useParams } from "react-router";
import { URL_SLUG_ID_SEPARATOR } from "src/utils/combineSlugId";

type ParamName = "slug" | "id" | "deal";

export const useExtractId = (paramName: ParamName = "slug"): string => {
  const params = useParams<Record<string, string>>();
  const param = params[paramName];

  return param?.split(URL_SLUG_ID_SEPARATOR).pop();
};
